<template>
  <div>
    <v-btn
      v-if="currentUser?.hasPermission('cctv_reports.download_cctvreport')"
      class="mr-3 text-capitalize"
      color="primary"
      flat
      :loading="isDownloading"
      :disabled="loading"
      @click="emit('download-report-pressed')"
      >Download PDF</v-btn
    >

    <MoreOptionsMenuButton
      v-if="
        currentUser?.hasPermission('cctv_reports.add_cctvreportsummary') ||
        currentUser?.hasPermission('cctv_reports.change_cctvreportsummary')
      "
    >
      <template #button="props">
        <v-btn
          v-bind="props"
          :loading="loading"
          :disabled="loading || isDownloading"
          class="mr-3 text-capitalize"
          append-icon="mdi-menu-down"
          variant="outlined"
        >
          More Options
        </v-btn>
      </template>
      <v-list-item
        v-if="currentUser?.hasPermission('cctv_reports.add_cctvreportsummary') && !summaryExists"
        title="Create Summary Report"
        @click="emit('create-summary-report-pressed')"
      >
      </v-list-item>
      <v-list-item
        v-if="currentUser?.hasPermission('cctv_reports.change_cctvreportsummary') && summaryExists"
        title="Edit Summary Report"
        @click="emit('edit-summary-report-pressed')"
      >
      </v-list-item>
      <v-list-item
        v-if="currentUser?.hasPermission('cctv_reports.approve_cctvreport')"
        title="Share Report"
        @click="emit('share-report-pressed')"
      >
      </v-list-item>
    </MoreOptionsMenuButton>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores'

import MoreOptionsMenuButton from '@/components/common/MoreOptionsMenuButton.vue'

interface Props {
  loading?: boolean
  summaryExists?: boolean
  isDownloading?: boolean
}
defineProps<Props>()

interface Emit {
  (e: 'download-report-pressed'): void
  (e: 'create-summary-report-pressed'): void
  (e: 'edit-summary-report-pressed'): void
  (e: 'share-report-pressed'): void
}
const emit = defineEmits<Emit>()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)
</script>
